import { render } from "./Painting.vue?vue&type=template&id=2286f892&scoped=true"
import script from "./Painting.vue?vue&type=script&lang=js"
export * from "./Painting.vue?vue&type=script&lang=js"

import "./Painting.vue?vue&type=style&index=0&id=2286f892&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2286f892"]])

export default __exports__